module.exports = __webpack_public_path__ + "media/images/march8/march8-template-md-a603f5d6503402da5276fc87d1b52a91.png";